import {OperatorTypeEnum} from './operator-type.enum';

export class OperatorOptions {
  public AND: OperatorTypeEnum = OperatorTypeEnum.AND;
  public OR: OperatorTypeEnum = OperatorTypeEnum.OR;
}
